var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupreject({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200.046,
    height: 150.891,
    viewBox: "0 0 200.046 150.891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_182787",
    "data-name": "Group 182787",
    transform: "translate(17.613 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182774",
    "data-name": "Group 182774",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182844",
    "data-name": "Group 182844",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98667",
    "data-name": "Path 98667",
    d: "M39.741,166.209H156.6c12.722,0,24.72-5.2,32.111-14.053,9.317-11.164,16.6-29.981,6.352-59.878-19.651-57.356-88.38-56.545-103.334-36.726-20.016,26.528-45.653,44.914-61.619,44.914-4.144,0-8.717,1.541-13.2,4.207-31.726,18.856-15.8,61.536,22.831,61.536",
    transform: "translate(-17.613 -22.393)",
    fill: "#f2f2f2",
    opacity: 0.717
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98701",
    "data-name": "Path 98701",
    d: "M468.941,58.085a9.262,9.262,0,0,0-10.648,2.383,7.178,7.178,0,0,0-.841,1.236l-7.271,13.562c-1.1,2.061-4.569,1.358-4.569-.927V16.879a7.288,7.288,0,0,0-2.523-5.443,9.1,9.1,0,0,0-6.084-2.254c-4.762,0-8.615,3.449-8.615,7.7V57.938a2.512,2.512,0,0,1-2.641,2.36h0a2.512,2.512,0,0,1-2.641-2.36V7.693C423.108,3.444,419.252,0,414.5,0s-8.612,3.445-8.612,7.694V57.938a2.658,2.658,0,0,1-5.283,0V13.469c0-4.237-3.71-7.871-8.451-7.948-4.831-.079-8.773,3.4-8.773,7.693V57.938a2.658,2.658,0,0,1-5.283,0V23.993c0-4.237-3.71-7.871-8.451-7.948-4.83-.079-8.774,3.4-8.774,7.693V60.3h0V85.536c0,24,21.974,44.216,48.835,44.158,20.708-.045,38.371-11.627,45.374-27.937l17.909-33.407a7.017,7.017,0,0,0,.849-3.319,7.675,7.675,0,0,0-4.892-6.945",
    transform: "translate(-323.589 0.001)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98703",
    "data-name": "Path 98703",
    d: "M1009.822,350.2a.17.17,0,0,0,0-.336q-.67-.01-1.346-.01a.17.17,0,0,0,0,.336q.674,0,1.342.011Z",
    transform: "translate(-904.175 -313.714)",
    fill: "#325899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98710",
    "data-name": "Path 98710",
    d: "M598.935,408.3H574.427a16.64,16.64,0,0,0-16.639,16.64v34.956h7.949V425.925a9.678,9.678,0,0,1,9.678-9.678h22.532a9.679,9.679,0,0,1,9.679,9.679v33.967h7.949V424.938a16.639,16.639,0,0,0-16.639-16.64",
    transform: "translate(-500.169 -366.121)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98711",
    "data-name": "Path 98711",
    d: "M382.971,762.634v12.771a46.952,46.952,0,0,0,93.9,0V762.634a13.816,13.816,0,0,0-13.816-13.816H396.787a13.816,13.816,0,0,0-13.816,13.816",
    transform: "translate(-343.411 -671.466)",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98712",
    "data-name": "Path 98712",
    d: "M663.117,914.9A19.586,19.586,0,1,1,682.7,934.487,19.586,19.586,0,0,1,663.117,914.9",
    transform: "translate(-594.618 -802.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98713",
    "data-name": "Path 98713",
    d: "M687.657,936.905a17.051,17.051,0,1,1,17.051,17.051,17.051,17.051,0,0,1-17.051-17.051",
    transform: "translate(-616.623 -824.834)",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98714",
    "data-name": "Path 98714",
    d: "M809.132,980.268a5.675,5.675,0,1,0-8.606,4.853l-1.03,12.992a.917.917,0,0,0,.914.989h6.1a.916.916,0,0,0,.914-.989l-1.03-12.992a5.666,5.666,0,0,0,2.744-4.853",
    transform: "translate(-715.371 -873.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98727",
    "data-name": "Path 98727",
    d: "M1054.024,1139.124l-19.376-33.561a1.583,1.583,0,0,0-2.742,0l-19.376,33.561a1.583,1.583,0,0,0,1.371,2.375h38.753a1.583,1.583,0,0,0,1.371-2.375",
    transform: "translate(-907.745 -990.651)",
    fill: "#d94559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98728",
    "data-name": "Path 98728",
    d: "M1078.131,1168.485l-16.894-29.261a.939.939,0,0,0-1.626,0l-16.894,29.261a.939.939,0,0,0,.813,1.409h33.788a.939.939,0,0,0,.813-1.409",
    transform: "translate(-934.891 -1021.123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98729",
    "data-name": "Path 98729",
    d: "M1078.147,1168.485l-16.894-29.261a.939.939,0,0,0-1.626,0l-.09.157,16.244,28.135a.939.939,0,0,1-.813,1.408h-32.359a.939.939,0,0,0,.938.97h33.788a.939.939,0,0,0,.813-1.409",
    transform: "translate(-934.908 -1021.123)",
    fill: "#dde4f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98730",
    "data-name": "Path 98730",
    d: "M1191.333,1228.945a1.7,1.7,0,0,1-1.682-1.546l-1.066-12.613a1.688,1.688,0,0,1,1.682-1.83h2.132a1.688,1.688,0,0,1,1.682,1.83l-1.066,12.613a1.7,1.7,0,0,1-1.682,1.546",
    transform: "translate(-1065.801 -1087.659)",
    fill: "#dde4f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98731",
    "data-name": "Path 98731",
    d: "M1197.143,1218.247h-2.132a1.141,1.141,0,0,0-1.137,1.238l1.066,12.613a1.141,1.141,0,0,0,2.275,0l1.066-12.613a1.141,1.141,0,0,0-1.137-1.238",
    transform: "translate(-1070.545 -1092.404)",
    fill: "#d94559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98732",
    "data-name": "Path 98732",
    d: "M1198.656,1377.565a1.91,1.91,0,1,1,1.91-1.91,1.913,1.913,0,0,1-1.91,1.91",
    transform: "translate(-1073.124 -1231.838)",
    fill: "#dde4f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98733",
    "data-name": "Path 98733",
    d: "M1202.037,1380.4a1.364,1.364,0,1,1,1.364,1.364,1.364,1.364,0,0,1-1.364-1.364",
    transform: "translate(-1077.868 -1236.583)",
    fill: "#d94559"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupreject);
export default __webpack_public_path__ + "static/media/groupreject.cb2641605056597a107a034e69e2209b.svg";
export { ForwardRef as ReactComponent };